import { EMPORION_ICON_FALLBACK, getEmporionIconComponent } from './registry'
import type { EmporionIconProps } from './types'

export const EmporionIcon = ({
  name,
  fallbackName = EMPORION_ICON_FALLBACK,
  title,
  'aria-label': ariaLabel,
  role,
  ...props
}: EmporionIconProps) => {
  const Icon = getEmporionIconComponent(name, fallbackName)
  const accessibleLabel = ariaLabel ?? title

  return (
    <Icon
      aria-hidden={accessibleLabel ? undefined : true}
      aria-label={accessibleLabel}
      role={role ?? (accessibleLabel ? 'img' : undefined)}
      {...props}
    />
  )
}
